import { render, staticRenderFns } from "./create_card_on_file.vue?vue&type=template&id=08c1e1aa&"
import script from "./create_card_on_file.vue?vue&type=script&lang=js&"
export * from "./create_card_on_file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports